export class YandexMetrika {

    track(code, eventCode) {

        console.log('YandexMetrika: ' + code + ':' + eventCode)

        try {
            window.ym(34776690, code, eventCode);
        } catch (e) {
            console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack)
        }
    };

    roomSent() {
        this.track('reachGoal', 'PMfrmShowroomSent');
    }
    clickPhone() {
        this.track('reachGoal', 'PMlnkContactHeader');
    }
    clickPhoneFooter() {
        this.track('reachGoal', 'PMlnkContactFooter');
    }
    callMe() {
        this.track('reachGoal', 'PMfrmCallMeSent');
    }
    addComment() {
        this.track('reachGoal', 'PMfrmCommentSent');
    }
    calcSend() {
        this.track('reachGoal', 'PMfrmCalcSent');
    }
    partSend() {
        this.track('reachGoal', 'PMfrmPartnerSent');
    }
    addProduct() {
        this.track('reachGoal', 'PMbtnAddToCart');
    }

    purchase() {
        this.track('reachGoal', 'PMfrmPurchase');
    }
}
